import { useEffect, useState } from "react";
import { X } from "lucide-react";
import logo from "@/assets/trata-health-logo.png";

const DISMISS_KEY = "trata_smart_banner_dismissed";
const APP_SCHEME = "trata-health-patient://main/home";

function isMobileBrowser() {
  if (typeof navigator === "undefined") return false;
  return /android|iphone|ipad|ipod/i.test(navigator.userAgent);
}

// Slim "Open in app" banner shown only on mobile browsers (deep-links into the Expo app).
export default function SmartAppBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isMobileBrowser() && !localStorage.getItem(DISMISS_KEY)) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const openApp = () => {
    // Attempt to open the native app via its custom scheme.
    window.location.href = APP_SCHEME;
  };

  return (
    <div className="md:hidden flex items-center gap-3 bg-card border-b border-border px-3 py-2 animate-slide-down" data-testid="smart-app-banner">
      <button onClick={dismiss} aria-label="Dismiss" data-testid="smart-banner-dismiss" className="text-muted-foreground">
        <X className="h-4 w-4" />
      </button>
      <img src={logo} alt="Trata Health" className="h-9 w-9 rounded-lg object-contain" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold leading-none">Trata Health app</p>
        <p className="text-xs text-muted-foreground mt-0.5 truncate">Faster, with voice AI & emergency SOS</p>
      </div>
      <button onClick={openApp} data-testid="smart-banner-open" className="shrink-0 text-sm font-semibold text-primary px-3 py-1.5 rounded-full bg-accent">
        Open
      </button>
    </div>
  );
}
